import { Link } from 'gatsby';
import propType from 'prop-types';
import React from 'react';
import { normalizePath } from '../../../utils/get-url-path';
import stripHtmlTag from '../../../utils/stripHtmlTag';
import BravoImage from '../../BravoImage';
import IconText from '../../IconText';
import PillarIcon from '../../../assets/svgs/pillar.svg';

const getComponent = (list, key) => {
  return list?.filter((comp) => {
    return comp.key === key;
  });
};

const Card = ({ type, imageSrc, uri, title, children, ...props }) => {
  const LinkToDetail = ({ children: content, ...linkProps }) => (
    <Link to={normalizePath(uri)} {...linkProps}>
      {content}
    </Link>
  );

  return (
    <article {...props} className={`card card--${type} ${props?.className}`}>
      <LinkToDetail className="card__image__wrapper">
        <BravoImage src={imageSrc} alt={title} className="card__image" />
      </LinkToDetail>
      <header className="card__content-wrapper">
        <LinkToDetail>
          {children?.length ? getComponent(children, 'content') : children}
        </LinkToDetail>
        {children?.length && getComponent(children, 'extra')}
      </header>
    </article>
  );
};

Card.defaultProps = {
  imageSrc: {},
  children: null,
  type: 'vertical',
  className: ''
};

Card.propTypes = {
  title: propType.string.isRequired,
  uri: propType.string.isRequired,
  imageSrc: propType.shape({}),
  children: propType.node,
  type: propType.oneOf(['vertical, horizontal']),
  className: propType.string
};

const Content = ({ children, ...props }) => {
  return (
    <div {...props} className={`card-content ${props.className}`}>
      {children}
    </div>
  );
};
Content.defaultProps = {
  className: ''
};
Content.propTypes = {
  children: propType.node.isRequired,
  className: propType.string
};

const Extra = ({ children }) => {
  return <div className="card-extra">{children}</div>;
};
Extra.propTypes = {
  children: propType.node.isRequired
};

const Title = ({ children, ...props }) => {
  const title = stripHtmlTag(children);
  return (
    <h2 {...props} className={`card-title ${props.className}`}>
      {title}
    </h2>
  );
};
Title.defaultProps = {
  className: ''
};
Title.propTypes = {
  children: propType.string.isRequired,
  className: propType.string
};

const Description = ({ children, ...props }) => {
  return (
    <p
      {...props}
      className={`card-subtitle ${props.className}`}
      dangerouslySetInnerHTML={{ __html: children }}
    />
  );
};
Description.defaultProps = {
  className: ''
};
Description.propTypes = {
  children: propType.string.isRequired,
  className: propType.string
};

const Topic = ({ topic }) => {
  const content = topic?.nodes[0]?.pillarPost;
  return (
    <IconText to={content?.uri} icon={<PillarIcon />}>
      {content?.customPostField?.topic}
    </IconText>
  );
};
Topic.propTypes = {
  topic: propType.shape({
    nodes: propType.arrayOf(
      propType.shape({
        uri: propType.string.isRequired,
        name: propType.string.isRequired,
        pillarPost: propType.shape({
          uri: propType.string,
          customPostField: propType.shape({
            topic: propType.string
          })
        })
      })
    )
  }).isRequired
};

Card.Title = Title;
Card.Description = Description;
Card.Topic = Topic;
Card.Content = Content;
Card.Extra = Extra;

export default Card;
